import axios from "axios";
import { SearchRequest } from "./Types";

export default {
  getDictionary(name) {
    const request: SearchRequest = {
      page: 1,
      count: 0,
    };
    return axios.post(`/nsi/SystemDictionary/${name}/Items`, request);
  },
  getUserDictionary(id) {
    return axios.get(`/nsi/dictionary/${id}/Items`);
  },
};
